import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";
import Toggle from "../../../components/Toggle";

export default function FinanciarStep({ data, errors, update, toggleField }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField label="Chiria lunara" value={data.chirie} onChange={update("chirie")} placeholder="ex: 400" type="number" required half error={errors.chirie} />
      <SelectField
        label="Valuta"
        value={data.valuta}
        onChange={update("valuta")}
        options={[
          { value: "EUR", label: "EUR (euro)" },
          { value: "RON", label: "RON (lei)" },
          { value: "USD", label: "USD ($)" },
        ]}
        half
      />
      <SelectField
        label="Garantie"
        value={data.garantie}
        onChange={update("garantie")}
        options={[
          { value: "1", label: "1 chirie lunara" },
          { value: "1.5", label: "1.5 chirii lunare" },
          { value: "2", label: "2 chirii lunare" },
        ]}
        half
      />
      <SelectField
        label="Ziua de plata"
        value={data.ziuaPlata}
        onChange={update("ziuaPlata")}
        options={Array.from({ length: 28 }, (_, i) => ({
          value: String(i + 1),
          label: `${i + 1} ale lunii`,
        }))}
        half
      />
      <InputField label="Data inceput contract" value={data.dataInceput} onChange={update("dataInceput")} type="date" required half error={errors.dataInceput} />
      <SelectField
        label="Durata contractului"
        value={data.durata}
        onChange={update("durata")}
        options={[
          { value: "6", label: "6 luni" },
          { value: "12", label: "12 luni (1 an)" },
          { value: "24", label: "24 luni (2 ani)" },
          { value: "36", label: "36 luni (3 ani)" },
        ]}
        half
      />
      <SelectField
        label="Termen plata utilitati (zile de la primirea facturii)"
        value={data.zilePlatUtilitati}
        onChange={update("zilePlatUtilitati")}
        options={[
          { value: "5", label: "5 zile" },
          { value: "10", label: "10 zile" },
          { value: "15", label: "15 zile" },
          { value: "20", label: "20 zile" },
          { value: "30", label: "30 zile" },
        ]}
        half
      />
      <div style={{ flex: "1 1 100%", minWidth: "220px" }}>
        <Toggle label="Penalizare de intarziere" description="Se aplica penalitati procentuale pe zi pentru intarzierea la plata chiriei" checked={data.penalizareActiva} onChange={toggleField("penalizareActiva")} />
      </div>
      {data.penalizareActiva && (
        <SelectField
          label="Penalizare intarziere (% pe zi)"
          value={data.penalizare}
          onChange={update("penalizare")}
          options={[
            { value: "0.01", label: "0.01% pe zi" },
            { value: "0.05", label: "0.05% pe zi" },
            { value: "0.1", label: "0.1% pe zi" },
            { value: "0.15", label: "0.15% pe zi" },
            { value: "0.2", label: "0.2% pe zi" },
          ]}
          half
        />
      )}
    </div>
  );
}
